/**
 * Stub for @react-native-async-storage/async-storage
 * Used when building for web to prevent webpack from trying to resolve React Native modules
 */

// Export empty implementations - the actual code will fall back to localStorage
const AsyncStorage = {
  getItem: async () => {
    throw new Error('AsyncStorage not available in web build');
  },
  setItem: async () => {
    throw new Error('AsyncStorage not available in web build');
  },
  removeItem: async () => {
    throw new Error('AsyncStorage not available in web build');
  },
  clear: async () => {
    throw new Error('AsyncStorage not available in web build');
  },
  getAllKeys: async () => {
    throw new Error('AsyncStorage not available in web build');
  },
};

module.exports = {
  default: AsyncStorage,
};

